import { createSuitMixin as e } from "../mixins/suit.js";
import { createWidgetMixin as t } from "../mixins/widget.js";
import { connectToggleRefinement as i } from "instantsearch.js/es/connectors/index.js";
import { createPanelConsumerMixin as r } from "../mixins/panel.js";
export default {
  name: "AisToggleRefinement",
  mixins: [e({
    name: "ToggleRefinement"
  }), t({
    connector: i
  }, {
    $$widgetType: "ais.toggleRefinement"
  }), r()],
  props: {
    attribute: {
      type: String,
      required: !0
    },
    on: {
      type: [String, Number, Boolean, Array],
      required: !1,
      default: !0
    },
    off: {
      type: [String, Number, Boolean, Array],
      required: !1,
      default: void 0
    },
    label: {
      type: String,
      default: void 0
    }
  },
  computed: {
    widgetParams: function widgetParams() {
      return {
        attribute: this.attribute,
        on: this.on,
        off: this.off
      };
    }
  }
};